<template>
    <div class="CSChatThai" style="background: #2562af;">
     <div style="background: #2562af !important; padding: 10px;">

  <v-btn icon @click="goback()" style="margin: 0 !important;">
        <v-icon class="white--text" style="font-size: 24px;">chevron_left</v-icon>
      </v-btn>
 

 <span style="color: white;font-weight: 800; margin-left: 25vw;">สถานะ</span>

</div>





<div style="padding: 10px; border-top-left-radius: 20px;
    border-top-right-radius: 20px;background: #fafafa;">
<v-layout row wrap>
  <v-flex xs12 xl12 lg12 md12 sm12>
<p class="HeadersDetail">สถานะ</p>
<v-text-field
              solo
              placeholder="สถานะ"
              height="35"
              v-model="status"
              counter="75"
            ></v-text-field>
<v-btn class="btnSave" :disabled="(status.length > 75)? true:false" small @click="Save_status()">บันทึก</v-btn>

      
    </v-flex>
  </v-layout>
  </div>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'

const get_detailuser = gql`
query MyQuery($user_id: uuid) {
  users(where: {user_id: {_eq: $user_id}}) {
    status
  }
}
`

const SET_STATUS = gql`
mutation ($user_id: uuid, $status: String) {
  update_users(where: {user_id: {_eq: $user_id}}, _set: {status: $status}) {
    returning {
      display_name
      status
      user_id
    }
  }
}
`

export default {
  data: () => ({
    detailUser: {},
    user_id: '',
    Authorization: {},
    status: '',
    backend: process.env.VUE_APP_API,
  }),
  apollo: {
  },
  computed: {
    ...sync('*')
  },
  created () {
    // this.$session.set('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.$apollo.query({
        query: get_detailuser,
        variables: {
          user_id: this.user_id
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        this.detailUser = response.data.users[0]
        this.status = this.detailUser.status
      })
    },
    Save_status () {
      this.$apollo.mutate({
        mutation: SET_STATUS,
        variables: {
          user_id: this.user_id,
          status: this.status
        }
      })
      this.goback()
    },
    gotopath (path) {
      this.$router.push(path)
    },
    goback () {
      this.$router.back()
    }
  }
    
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}

>>>.theme--light.v-input:not(.v-input--is-disabled) input {
    color: #2562af !important;
}


.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}


>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    background: #f3f3f3 !important;
    border-radius: 5px !important;
    border: 2px solid #2562af !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
/*>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}*/
>>>.v-input__icon .v-input__icon--prepend-inner .v-icon {
  font-size: 13px !important;
}
>>>.v-icon {
    font-size: inherit;
  }

  >>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}

.theme--light.v-list {
    background: #fafafa;
    color: rgba(0,0,0,.87);
}

.HeadersDetail {
  margin-top: 5vh;
  color: #2562af;
  margin-bottom: 0px !important;
  padding-left: 3px;
  font-size: 12px; 
}
.btnSave {
  color: white !important;
  background: #2562af !important;
  box-shadow: none !important;
  margin: 20px auto !important;
  display: flex !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mail/Edit/edit_status.vue